import { render, staticRenderFns } from "./ReviewGradeSheetAll.vue?vue&type=template&id=99bc4a72&scoped=true"
import script from "./ReviewGradeSheetAll.vue?vue&type=script&lang=js"
export * from "./ReviewGradeSheetAll.vue?vue&type=script&lang=js"
import style0 from "./ReviewGradeSheetAll.vue?vue&type=style&index=0&id=99bc4a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bc4a72",
  null
  
)

export default component.exports